import { render, staticRenderFns } from "./PageGrid.vue?vue&type=template&id=7bc40384&scoped=true&"
import script from "./PageGrid.vue?vue&type=script&lang=js&"
export * from "./PageGrid.vue?vue&type=script&lang=js&"
import style0 from "./PageGrid.vue?vue&type=style&index=0&id=7bc40384&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bc40384",
  null
  
)

export default component.exports